import React from 'react'
import styles from './sectionHeader.module.sass'

// A takeaway sentence with one phrase underlined in lime.
export type Intro = { before: string; highlight: string; after: string }

type Props = {
  title: string
  intro?: Intro
}

export const SectionHeader = ({ title, intro }: Props) => (
  <div className={styles.header}>
    <h2 className={styles.title}>{title}</h2>
    <IntroLine intro={intro} />
  </div>
)

const IntroLine = ({ intro }: { intro?: Intro }) => {
  if (!intro) return null

  return (
    <p className={styles.intro}>
      {intro.before}
      <Highlight text={intro.highlight} />
      {intro.after}
    </p>
  )
}

const Highlight = ({ text }: { text: string }) => {
  if (!text) return null

  return <span className={styles.highlight}>{text}</span>
}
